import { render, staticRenderFns } from "./chatDataListAll.vue?vue&type=template&id=4d9a5ed6&scoped=true&"
import script from "./chatDataListAll.vue?vue&type=script&lang=js&"
export * from "./chatDataListAll.vue?vue&type=script&lang=js&"
import style0 from "./chatDataListAll.vue?vue&type=style&index=0&id=4d9a5ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9a5ed6",
  null
  
)

export default component.exports